import {MilestoneIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'
import {Octicon} from '@primer/react/deprecated'

import styles from './MilestoneMetadata.module.css'

type MilestoneMetadataProps = {
  title: string
  url: string
}

export const MilestoneMetadata = ({title, url}: MilestoneMetadataProps) => {
  return (
    <>
      <span> · </span>
      <Link href={url} muted aria-label={title} className={styles.milestoneLink}>
        <Octicon icon={MilestoneIcon} size={16} />
        &nbsp;
        <Truncate title={title} className={styles.milestoneTitleTruncate}>
          {title}
        </Truncate>
      </Link>
    </>
  )
}
